// The verdicts codeforces sends back, written out the way a competitor says
// them. Anything not listed here keeps the name the judge recorded.
const VERDICT_LABELS = {
    OK: 'Accepted',
    WRONG_ANSWER: 'WA',
    TIME_LIMIT_EXCEEDED: 'TLE',
    MEMORY_LIMIT_EXCEEDED: 'MLE',
    RUNTIME_ERROR: 'RE',
    COMPILATION_ERROR: 'CE'
};

const verdictLabel = verdict => VERDICT_LABELS[verdict] ?? verdict;

export { VERDICT_LABELS, verdictLabel as default };
